import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import useTsPaginator from 'ts-paginator';
import Paginator from '../../../layout/Pagination';

const TelematicsActivityDataTable = ({ entries, pagination, handlePageOrRowsChange, uploadSuccess }) => {

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        _determineRowsPerPageOptions,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(pagination.total_records, pagination.current_page, pagination.rows_per_page);

    const handlePageChange = (page) => {
        const totalPages = Math.ceil(totalRecordCount / rowsPerPage);
        const newPage = Math.min(Math.max(page, 1), totalPages); // Ensure page is within valid range
        _handleChangePage(newPage);
        handlePageOrRowsChange(rowsPerPage, newPage);
    };

    const handleRowsChange = (e) => {
        const newRowsPerPage = parseInt(e, 10);
        const newPage = 1; // Reset to page 1 when rows per page change
        _handleChangeRowsPerPage(newRowsPerPage);
        handlePageOrRowsChange(newRowsPerPage, newPage);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Machine Name</TableCell>
                            <TableCell>Serial Number</TableCell>
                            <TableCell>Production Time</TableCell>
                            <TableCell>Refuelling Time</TableCell>
                            <TableCell>Idle Time</TableCell>
                            <TableCell>Shutdown Time</TableCell>
                            <TableCell>Service Time</TableCell>
                            <TableCell>No Report</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {entries?.map((entry, i) => (
                            <TableRow key={i}>
                                <TableCell>{entry.date}</TableCell>
                                <TableCell>{entry.machineName}</TableCell>
                                <TableCell>{entry.serialNumber}</TableCell>
                                <TableCell>{entry.productionTime}</TableCell>
                                <TableCell>{entry.refuellingTime}</TableCell>
                                <TableCell>{entry.idleTime}</TableCell>
                                <TableCell>{entry.shutdownTime}</TableCell>
                                <TableCell>{entry.serviceTime}</TableCell>
                                <TableCell>{entry.noReport}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {console.log('renders')}
            <Paginator
                key={`${rowsPerPage}-${pagination.total_records}-${pagination.rows_per_page}-${uploadSuccess}`}
                totalRecordCount={totalRecordCount}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                handleChangePage={handlePageChange}
                handleChangeRowsPerPage={handleRowsChange}
                determinePaginationMessage={_determinePaginationMessage}
                determinePaginationDisabledState={_determinePaginationDisabledState}
                determineRowsPerPageOptions={_determineRowsPerPageOptions}
            />
        </Box>
    );
};

export default TelematicsActivityDataTable;